function Search_algolia_instantsearch(element) {
  this.loaded = false;
  this.algoliaInstantsearchSrc = element.dataset.algoliaInstantsearchSrc;


  /**
   * init decorator
   */
  this.init = function() {
    console.log("Search_algolia_instantsearch init...");

    if (!this.loaded) {
      this.loadAlgoliaLibraries();
    }

    this.loaded = true;
  };


  /**
   * inject remote CDN script used for the algolia instantsearch client
   */
  this.loadAlgoliaLibraries = function () {
    let instantsearch = document.createElement('script');
    instantsearch.type = 'text/javascript';
    instantsearch.src = this.algoliaInstantsearchSrc; console.log(instantsearch);

    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(instantsearch, s);
  };
}
